module.exports = __webpack_public_path__ + "static/media/overlay_stars.0390ba85.svg";